const WIDTH = 600, FLOOR = 495, HERO_X = 150;
const STORAGE_KEY = 'chefman-melt-down-hi';
export function createMeltGame() {
  return {state:'ready', y:250, velocity:0, score:0, cool:100, distance:0, travel:0, lastCenter:245, towers:[], cubes:[], spawned:0, pickup:0, reason:null};
}
export function flapMelt(game) {
  if (!['ready','playing'].includes(game.state)) return;
  game.state='playing';game.velocity=-295;
}
export function pauseMelt(game) {
  if (!['ready','playing'].includes(game.state)) return;
  game.resumeState=game.state;game.state='paused';
}
export function resumeMelt(game) {
  if(game.state==='paused'){game.state=game.resumeState;delete game.resumeState;}
}
export function spawnMeltTower(game, random=Math.random) {
  const level=Math.floor(game.score/10), gap=Math.max(150,205-level*5), half=gap/2;
  const min=35+half, max=FLOOR-35-half;
  const delta=55+random()*65;
  let center=game.lastCenter+(random()<.5?-delta:delta);
  if(center<min||center>max) center=game.lastCenter+(center<min?delta:-delta);
  center=Math.max(min,Math.min(max,center));game.lastCenter=center;
  const tower={x:WIDTH+40,w:65,top:center-half,bottom:center+half,kind:game.spawned%5,passed:false};
  game.towers.push(tower);
  if(game.spawned%2===0)game.cubes.push({x:tower.x+155,y:center,taken:false});
  game.spawned++;return tower;
}
export function advanceMelt(game, elapsed, random=Math.random) {
  if(game.state!=='playing')return;
  const dt=Math.min(.04,Math.max(0,elapsed)), speed=Math.min(215,130+Math.floor(game.score/10)*8), dx=speed*dt;
  game.velocity=Math.min(430,game.velocity+850*dt);game.y+=game.velocity*dt;
  if(game.y<25){game.y=25;game.velocity=0;}
  game.distance+=dx;game.travel+=dx;game.cool=Math.max(0,game.cool-dx*.045);game.pickup=Math.max(0,game.pickup-dt);
  if(!game.spawned||game.travel>=280){spawnMeltTower(game,random);game.travel=0;}
  const lose=reason=>{game.state='over';game.reason=reason;};
  // A forgiving hitbox sits inside the scoop and cone. Decorative wings do not collide.
  const left=HERO_X-12,right=HERO_X+12,top=game.y-18,bottom=game.y+22;
  for(const tower of game.towers){
    tower.x-=dx;
    if(right>tower.x&&left<tower.x+tower.w&&(top<tower.top||bottom>tower.bottom))lose('collision');
    if(!tower.passed&&tower.x+tower.w<left){tower.passed=true;if(game.state==='playing')game.score++;}
  }
  for(const cube of game.cubes){cube.x-=dx;if(!cube.taken&&Math.abs(cube.x-HERO_X)<29&&Math.abs(cube.y-game.y)<37){cube.taken=true;game.cool=Math.min(100,game.cool+48);game.pickup=1.1;}}
  game.towers=game.towers.filter(t=>t.x+t.w>-10);game.cubes=game.cubes.filter(c=>c.x>-30&&!c.taken);
  if(bottom>=FLOOR)lose('ground');
  if(game.cool<=0&&game.state==='playing')lose('melted');
}

if(typeof window!=='undefined'&&!customElements.get('melt-down'))customElements.define('melt-down',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;this.controller=new AbortController();
    const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.controller.signal});
    this.game=createMeltGame();this.game.state='idle';this.best=0;this.lastMessage='';
    try{this.best=Math.max(0,parseInt(localStorage.getItem(STORAGE_KEY),10)||0);}catch{}
    this.canvas=this.querySelector('canvas');this.ctx=this.canvas.getContext('2d');this.flapButton=this.querySelector('[data-flap]');
    on(this.querySelector('[data-play]'),'click',()=>{
      if(this.game.state==='paused')resumeMelt(this.game);else this.game=createMeltGame();
      this.querySelector('[data-overlay]').hidden=true;this.sync();this.flapButton.focus({preventScroll:true});this.draw();if(this.game.state==='playing')this.run();
    });
    on(this.flapButton,'click',()=>this.flap());
    on(this.canvas,'pointerdown',e=>{if(e.button!==0)return;e.preventDefault();this.flap();if(!this.flapButton.disabled)this.flapButton.focus({preventScroll:true});});
    on(this.querySelector('[data-pause]'),'click',()=>this.pause());
    on(this,'keydown',e=>{
      if(e.repeat||e.target.matches('input,textarea,select')||e.target.isContentEditable)return;
      if(['p','Escape'].includes(e.key)||e.key==='P'){e.preventDefault();this.pause();}
      if([' ','Enter','ArrowUp'].includes(e.key)&&['ready','playing'].includes(this.game.state)&&!e.target.matches('[data-pause]')){e.preventDefault();this.flap();}
    });
    on(this,'focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))this.pause();});
    on(window,'blur',()=>this.pause());on(document,'visibilitychange',()=>{if(document.hidden)this.pause();});
    this.observer=new ResizeObserver(()=>this.resize());this.observer.observe(this.canvas);this.sync();this.resize();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.controller=null;}
  resize(){const rect=this.canvas.getBoundingClientRect();if(!rect.width)return;const dpr=Math.min(devicePixelRatio||1,2);this.canvas.width=Math.round(rect.width*dpr);this.canvas.height=Math.round(rect.height*dpr);this.draw();}
  flap(){const state=this.game.state;flapMelt(this.game);if(state==='ready'){this.sync();this.run();}}
  run(){cancelAnimationFrame(this.frame);this.last=performance.now();this.frame=requestAnimationFrame(t=>this.tick(t));}
  tick(t){advanceMelt(this.game,(t-this.last)/1000);this.last=t;this.sync();this.draw();if(this.game.state==='playing')this.frame=requestAnimationFrame(time=>this.tick(time));}
  pause(){if(!['ready','playing'].includes(this.game.state))return;pauseMelt(this.game);cancelAnimationFrame(this.frame);this.sync();this.overlay('ON ICE','Take a little breather.','Your scoop, score, and cooling meter are saved right here.','Keep flying');}
  overlay(kicker,title,message,button){this.querySelector('[data-kicker]').textContent=kicker;this.querySelector('[data-title]').textContent=title;this.querySelector('[data-message]').textContent=message;this.querySelector('[data-play]').textContent=button+' →';this.querySelector('[data-overlay]').hidden=false;this.querySelector('[data-play]').focus({preventScroll:true});}
  sync(){
    const g=this.game;if(g.score>this.best){this.best=g.score;try{localStorage.setItem(STORAGE_KEY,String(this.best));}catch{}}
    this.querySelector('[data-score]').textContent=g.score;this.querySelector('[data-best]').textContent=this.best;
    const cool=Math.ceil(g.cool);this.querySelector('[data-cool-number]').textContent=cool+'%';this.querySelector('[data-cool]').style.transform=`scaleX(${g.cool/100})`;this.querySelector('[data-meter]').setAttribute('aria-valuenow',cool);this.dataset.low=String(cool<30);
    this.flapButton.disabled=!['ready','playing'].includes(g.state);this.querySelector('[data-pause]').disabled=this.flapButton.disabled;
    let message='Your next sweet escape starts here.',tone='';
    if(g.state==='ready')message='Ready? Tap the scene or press Space to take off.';
    if(g.state==='playing'){message=g.pickup>0?'Ice collected. Cooling meter refilled!':cool<30?'Getting warm! Collect an ice cube to keep flying.':'Thread the gaps. Catch the ice. Keep your cool.';tone=g.pickup>0?'ice':cool<30?'danger':'';}
    if(g.state==='paused')message='Paused. Take your time.';
    if(g.state==='over'){message=g.reason==='melted'?'Melt down! Your cooling meter ran out.':g.reason==='ground'?'A bumpy landing. Keep tapping to stay in the air.':'That sweet was a little too close. Try the next gap.';tone='danger';}
    if(message!==this.lastMessage){this.querySelector('[data-feedback]').textContent=message;this.lastMessage=message;}this.querySelector('[data-feedback]').dataset.tone=tone;
    if(g.state==='over'&&this.querySelector('[data-overlay]').hidden)this.overlay('A SWEET RUN',g.reason==='melted'?'Time to chill.':'One more scoop?',`${message} Score: ${g.score}. Personal best: ${this.best}.`,'Fly again');
  }
  draw(){
    if(!this.ctx)return;const c=this.ctx,g=this.game;
    c.setTransform(this.canvas.width/600,0,0,this.canvas.height/530,0,0);
    const rect=(x,y,w,h,r,color)=>{c.fillStyle=color;c.beginPath();c.roundRect(x,y,w,h,r);c.fill();};
    const ellipse=(x,y,rx,ry,color)=>{c.fillStyle=color;c.beginPath();c.ellipse(x,y,rx,ry,0,0,Math.PI*2);c.fill();};
    const line=(x,y,x2,y2,color,width=1)=>{c.strokeStyle=color;c.lineWidth=width;c.beginPath();c.moveTo(x,y);c.lineTo(x2,y2);c.stroke();};
    const gradient=(x,y,x2,y2,a,b)=>{const grad=c.createLinearGradient(x,y,x2,y2);grad.addColorStop(0,a);grad.addColorStop(1,b);return grad;};
    const text=(s,x,y,size,color)=>{c.font=`${size}px "Instrument Sans",sans-serif`;c.textAlign='center';c.fillStyle=color;c.fillText(s,x,y);};
    c.fillStyle=gradient(0,0,0,530,'#e5f3f5','#fff1de');c.fillRect(0,0,600,530);
    // Soft candy-land layers sit behind the darker, solid collision obstacles.
    ellipse(492,78,38,38,'#ffe5a9');ellipse(483,69,23,23,'#fff0c5');
    const cloud=(x,y,scale)=>{c.save();c.translate(x,y);c.scale(scale,scale);ellipse(0,0,42,16,'#fffaf5');ellipse(-20,-10,23,20,'#fffaf5');ellipse(10,-18,28,25,'#fffaf5');ellipse(36,-4,20,15,'#fffaf5');c.restore();};
    for(let i=-1;i<4;i++)cloud(i*250+60-(g.distance*.06%250),72+(i%2?42:0),i%2?.8:1);
    // Meringue mountains with strawberry icing and tiny sugar sprinkles.
    for(let i=-1;i<4;i++){
      const x=i*245-(g.distance*.12%245), y=210+(i%2?30:0);
      c.fillStyle=i%2?'#efcad2':'#ded1ec';c.beginPath();c.moveTo(x-30,420);c.bezierCurveTo(x+12,y+80,x+38,y-35,x+94,y);c.bezierCurveTo(x+143,y+36,x+155,370,x+228,420);c.closePath();c.fill();
      c.fillStyle='#fff8ed';c.beginPath();c.moveTo(x+28,y+38);c.bezierCurveTo(x+46,y-11,x+70,y-18,x+94,y);c.bezierCurveTo(x+111,y+13,x+122,y+38,x+132,y+61);c.quadraticCurveTo(x+116,y+46,x+105,y+60);c.quadraticCurveTo(x+88,y+74,x+81,y+47);c.quadraticCurveTo(x+66,y+23,x+56,y+48);c.quadraticCurveTo(x+45,y+58,x+28,y+38);c.fill();
      for(let k=0;k<5;k++){const xx=x+52+(k%3)*20,yy=y+8+Math.floor(k/3)*16;line(xx,yy,xx+4,yy+3,['#e4a3b0','#bca8d4','#b7c8b1'][k%3],2);}
    }
    c.fillStyle='#c7dfd4';c.beginPath();c.moveTo(0,396);c.bezierCurveTo(160,287,294,441,420,353);c.bezierCurveTo(500,306,566,345,600,359);c.lineTo(600,530);c.lineTo(0,530);c.fill();
    c.fillStyle='#a9cfc4';c.beginPath();c.moveTo(0,459);c.bezierCurveTo(180,343,340,456,600,381);c.lineTo(600,530);c.lineTo(0,530);c.fill();
    // A winding strawberry ribbon and miniature lollipop trees complete the landscape.
    c.fillStyle='#f5c3c5';c.beginPath();c.moveTo(600,400);c.bezierCurveTo(349,408,518,452,263,470);c.bezierCurveTo(149,477,120,502,99,530);c.lineTo(260,530);c.bezierCurveTo(228,484,518,490,493,447);c.bezierCurveTo(484,428,545,417,600,411);c.closePath();c.fill();
    const lollipop=(x,y,r,color)=>{
      line(x,y,x,y+r+75,'#f9f3e4',7);line(x+3,y+4,x+3,y+r+75,'#c3bdad',1.5);
      ellipse(x+2,y+3,r,r,'#779e9026');ellipse(x,y,r,r,'#fff5e9');
      c.strokeStyle=color;c.lineWidth=5;c.lineCap='round';c.beginPath();
      for(let j=0;j<=90;j++){const a=j/90*Math.PI*5,rr=2+j/90*(r-5),px=x+Math.cos(a)*rr,py=y+Math.sin(a)*rr;if(j===0)c.moveTo(px,py);else c.lineTo(px,py);}c.stroke();c.lineCap='butt';
      ellipse(x-r*.3,y-r*.4,r*.18,r*.12,'#ffffffb0');
    };
    for(let i=-1;i<4;i++){const x=i*230+55-(g.distance*.2%230);lollipop(x,359+(i%2?22:0),i%2?22:29,i%2?'#c6acd9':'#e5a1b4');}
    // Dessert columns stay within their collision outlines; gaps remain visually unambiguous.
    const towerPart=(t,y,h,flipped)=>{
      if(h<=0)return;
      const colors=[['#79452c','#3f221b'],['#fb7fa5','#c83473'],['#64d6bf','#229a91'],['#fffdf3','#e8eced'],['#fff0cc','#dfc69b']][t.kind];
      rect(t.x,y,t.w,h,9,gradient(t.x,y,t.x+t.w,y,colors[0],colors[1]));
      c.save();c.beginPath();c.roundRect(t.x,y,t.w,h,9);c.clip();
      const sprinkles=(from,to,seed)=>{
        const palette=['#fff2b5','#79e4e7','#8247bc','#ffce48','#fdf9ee'];
        c.lineCap='round';
        // Stable positions attached to the candy, so decorations never flicker between frames.
        for(let row=0,yy=from;yy<to;row++,yy+=23){
          for(let col=0;col<3;col++){
            const n=row*7+col*3+seed,xx=t.x+10+col*21+(row%2?4:0),cy=yy+(col%2?7:0);
            line(xx,cy,xx+(n%2?4:-3),cy+5,palette[n%palette.length],3);
          }
        }
        c.lineCap='butt';
      };
      if(t.kind===0){
        // Raised chocolate squares, with deep grooves and beveled edges.
        for(let yy=y+5;yy<y+h;yy+=34){
          for(let col=0;col<2;col++){
            const xx=t.x+5+col*29;
            rect(xx,yy,26,31,3,'#321a16');
            rect(xx+1,yy+1,23,27,2,gradient(xx,yy,xx+24,yy+28,'#b67548','#653521'));
            line(xx+4,yy+4,xx+21,yy+4,'#d39b68',1.4);
            line(xx+3,yy+4,xx+3,yy+23,'#c18a59',1);
            line(xx+4,yy+25,xx+22,yy+25,'#4b241b',1.5);
            rect(xx+6,yy+7,13,15,2,'#85492e');
          }
        }
      }else if(t.kind===4){
        // An ice cream sandwich seen on its side: vanilla between two cocoa wafers.
        rect(t.x,y,21,h,4,gradient(t.x,y,t.x+21,y,'#784b39','#452921'));
        rect(t.x+44,y,21,h,4,gradient(t.x+44,y,t.x+65,y,'#87513b','#47291f'));
        rect(t.x+21,y,23,h,0,gradient(t.x+21,y,t.x+44,y,'#fff8e5','#e9d5aa'));
        for(let yy=y+8;yy<y+h;yy+=17){
          ellipse(t.x+23,yy,3,5,'#fff8e5');ellipse(t.x+42,yy+4,3,5,'#e9d5aa');
          for(const xx of [t.x+7,t.x+15,t.x+50,t.x+58]){
            ellipse(xx,yy,1.7,2,'#2d1915');ellipse(xx+.4,yy+1.5,1.3,.7,'#bd876055');
          }
        }
        line(t.x+3,y+5,t.x+3,y+h-5,'#b8825d',1.2);line(t.x+46,y+5,t.x+46,y+h-5,'#bb8561',1.2);
      }else if(t.kind===3){
        // Glossy peppermint twists: broad red ribbons wind around a solid white stick.
        for(let yy=y-85;yy<y+h+85;yy+=48){
          c.fillStyle='#ed4561';c.beginPath();c.moveTo(t.x,yy);c.bezierCurveTo(t.x+22,yy+20,t.x+43,yy+18,t.x+t.w,yy+41);c.lineTo(t.x+t.w,yy+61);c.bezierCurveTo(t.x+43,yy+39,t.x+22,yy+41,t.x,yy+20);c.closePath();c.fill();
          c.strokeStyle='#b92349';c.lineWidth=2;c.beginPath();c.moveTo(t.x,yy+20);c.bezierCurveTo(t.x+22,yy+41,t.x+43,yy+39,t.x+t.w,yy+61);c.stroke();
        }
        rect(t.x+9,y,7,h,3,'#ffffff77');rect(t.x+t.w-7,y,7,h,0,'#8b244022');
      }else{
        {
          rect(t.x+7,y+9,5,Math.max(0,h-18),2,'#ffffff44');
          if(t.kind===1)sprinkles(y+13,y+h-13,flipped?1:4);
          else{
            for(let yy=y+12;yy<y+h-12;yy+=27){
              for(let k=0;k<2;k++){const xx=t.x+19+k*28+(Math.round(yy-y)%2?3:0);c.fillStyle='#674332';c.beginPath();c.moveTo(xx-4,yy);c.lineTo(xx+3,yy-4);c.lineTo(xx+5,yy+3);c.lineTo(xx-2,yy+5);c.closePath();c.fill();}
            }
          }
        }
        const end=flipped?y+h:y,coating=t.kind===1?'#ffe4a2':'#573344';
        rect(t.x,end-(flipped?22:0),t.w,22,5,coating);
        for(let k=0;k<4;k++)ellipse(t.x+9+k*16,end+(flipped?-22:22),8,7,coating);
        sprinkles(end+(flipped?-18:8),end+(flipped?-7:18),t.kind+2);
      }
      c.restore();
      // Thin inset edges make the collision boundary clear without extending into the gap.
      c.strokeStyle=['#3f221b','#ac285b','#197c78','#bb345177','#62402c'][t.kind];c.lineWidth=1.5;
      c.beginPath();c.roundRect(t.x+.75,y+.75,t.w-1.5,h-1.5,8);c.stroke();

    };
    for(const tower of g.towers){towerPart(tower,0,tower.top,true);towerPart(tower,tower.bottom,FLOOR-tower.bottom,false);}
    for(const cube of g.cubes){
      c.save();c.translate(cube.x,cube.y);c.rotate(.15);rect(-14,-14,28,28,7,'#ffffffa0');rect(-11,-11,22,22,5,gradient(-12,-12,12,12,'#dffaff','#8cbacd'));line(-6,-6,6,-6,'#ffffff',2);line(-6,-6,-6,4,'#ffffff',2);c.restore();
    }
    // Strawberry icing over a golden waffle foreground, with moving rainbow sugar.
    rect(0,FLOOR,600,35,0,'#efb35b');rect(0,FLOOR,600,8,0,'#f46491');
    for(let x=-(g.distance%28);x<600;x+=28){ellipse(x+14,FLOOR+7,14,7,'#f46491');line(x,FLOOR+17,x+22,530,'#b4763655');line(x,530,x+22,FLOOR+17,'#ffde93');}
    for(let i=-1;i<24;i++){const x=i*28-(g.distance%28);line(x+5,FLOOR+3,x+10,FLOOR+5,['#fff2b5','#6de0db','#b69bea'][((i%3)+3)%3],2);}
    // Crisp outlined character, with a simple sprinkled scoop and waffle details.
    // Only the original inner body collides; wings remain decorative.
    c.save();c.translate(HERO_X,g.y);c.rotate(Math.max(-.25,Math.min(.45,g.velocity/800)));c.scale(1.12,1.12);
    const wingLift=g.state==='playing'?Math.sin(g.distance*.08)*4:0;
    for(const side of [-1,1]){
      c.save();c.scale(side,1);c.translate(0,wingLift);
      c.fillStyle='#fffdf5';c.strokeStyle='#536c7b';c.lineWidth=1.4;c.beginPath();c.moveTo(15,0);c.bezierCurveTo(22,-13,42,-16,36,-7);c.bezierCurveTo(49,-11,41,0,35,2);c.bezierCurveTo(42,2,32,12,17,8);c.closePath();c.fill();c.stroke();
      line(20,4,33,-3,'#a5c2d1',1.2);line(23,6,32,3,'#a5c2d1',1.2);c.restore();
    }
    c.fillStyle='#dba866';c.strokeStyle='#795438';c.lineWidth=1.6;c.beginPath();c.moveTo(-14,2);c.lineTo(14,2);c.lineTo(0,31);c.closePath();c.fill();c.stroke();
    c.save();c.clip();for(let y=-3;y<40;y+=8){line(-15,y,15,y+19,'#aa733e',1);line(-15,y+19,15,y,'#f7d69d',1.1);}c.restore();
    rect(-14,2,28,5,2,'#eec48c');
    c.fillStyle='#ffe9d4';c.strokeStyle='#835f53';c.lineWidth=1.6;c.beginPath();c.moveTo(-19,1);c.bezierCurveTo(-24,-11,-15,-26,-1,-25);c.bezierCurveTo(14,-27,24,-15,20,-2);c.bezierCurveTo(25,7,14,12,10,7);c.bezierCurveTo(5,14,-2,11,-5,7);c.bezierCurveTo(-13,13,-24,9,-19,1);c.closePath();c.fill();c.stroke();
    for(const [x,y,color] of [[-10,-20,'#e9b7d1'],[-2,-22,'#e9d087'],[9,-20,'#a9d8d4']])line(x,y,x+3,y-1,color,1.7);
    ellipse(-7,-3,2.3,3,'#263846');ellipse(7,-3,2.3,3,'#263846');ellipse(-7.6,-4.1,.7,.9,'#fff');ellipse(6.4,-4.1,.7,.9,'#fff');
    ellipse(-13,2,3,1.8,'#edb1a4');ellipse(13,2,3,1.8,'#edb1a4');
    c.strokeStyle='#704e42';c.lineWidth=1.6;c.lineCap='round';c.beginPath();c.arc(0,0,4.2,.15,Math.PI-.15);c.stroke();c.lineCap='butt';
    c.restore();
    if(g.pickup>0){text('+ COOL',HERO_X,g.y-53,13,'#315e74');}
    if(g.state==='ready'){rect(180,400,280,46,23,'#131e29ed');text('TAP TO TAKE OFF  ↑',320,429,13,'#f7f8f4');}
    if(g.state==='idle')text('A LITTLE LIFT. A LOT OF COOL.',300,474,10,'#516c7b');
  }
});
